import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MedicalRequest } from 'src/app/_models/PSP/medical-requests.model';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';
import { NearestPharmacyModalComponent } from '../../nearest-pharmacy-modal/nearest-pharmacy-modal.component';
import { DatePipe } from '@angular/common';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CancelRequestModalComponent } from '../cancel-request-modal/cancel-request-modal.component';
import { showNotification } from 'src/app/helpers/show-toast';
import { ToastrService } from 'ngx-toastr';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { PspMedicalRequestTypeEnum } from 'src/app/enums/psp-type.enum';
import { PspCompanyEnum } from 'src/app/enums/psp-company.enum';
import { ExcelService } from 'src/app/_services/excel.service';
import { isArabic as isArabicHelper } from 'src/app/helpers/IsArabic';
import { PreviewDocumentsModalComponent } from '@components/preview-documents-modal/preview-documents-modal.component';
@Component({
  selector: 'app-home-delivery',
  templateUrl: './home-delivery.component.html',
  styleUrls: ['./home-delivery.component.scss'],
})
export class HomeDeliveryComponent implements OnInit {
  pageTitle: string = 'Home Delivery';
  titles = [
    'All Requests',
    'Pending Requests',
    'Confirmed Requests',
    'Out of Delivery Requests',
    '',
    'Cancelled Requests',
    'Expired Requests',
    'Pending Receipt'
  ];
  statusId = 0;
  apiParams: any = {
    medicationRequestTypeIds: 1,
    medicationRequestStatusIds: '1',
    pageSize: 10,
    currentPage: 1,
    sort: true,
    companyId: 0
  };
  invertSort = true;
  totalItems: number;
  medicationRequestsCounter: any;
  requestArray: MedicalRequest[] = [];
  exportedRequestArray: MedicalRequest[] = [];
  modalRef: BsModalRef;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Oh !! There is No Requests',
    totalMessage: 'total',
    selectedMessage: ''
  };
  isArabic = isArabicHelper;

  @ViewChild('selectPharmacy') public selectPharmacy: TemplateRef<any>;
  @ViewChild('cancelBtnRef') public cancelBtnRef: TemplateRef<any>;
  @ViewChild('subscriptionHistoryTemplate', { static: true }) subscriptionHistoryTemplate: TemplateRef<any>;
  @ViewChild('packSerialNumberTemplate', { static: true }) packSerialNumberTemplate: TemplateRef<any>;
  @ViewChild('previewReceiptDocumentRef') public previewReceiptDocumentRef: TemplateRef<any>;
  @ViewChild('previewSerialNumberDocumentRef') public previewSerialNumberDocumentRef: TemplateRef<any>;

  searchValue = '';
  pageSelectionId = 1;
  filters = [
    {
      label: 'All',
      statusId: 0
    },
    {
      label: 'Pending Requests',
      statusId: 1
    },
    {
      label: 'Confirmed Requests',
      statusId: 2
    },
    {
      label: 'Out for Delivery Requests',
      statusId: 3
    },
    {
      label: 'Cancelled Requests',
      statusId: 5
    },
    {
      label: 'Expired Requests',
      statusId: 6
    },
    {
      label: 'Pending Receipt',
      statusId: 7
    }
  ];

  constructor(
    private readonly medicalRequestService: MedicationRequestService,
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private readonly bsModalService: BsModalService,
    private readonly datePipe: DatePipe,
    private readonly toastr: ToastrService,
    private readonly excelService: ExcelService
  ) { }

  ngOnInit(): void {
    this.onSearch(this.statusId);
  }

  onSearch(statusId: number): void {
    this.apiParams.medicationRequestStatusIds = statusId === 0 ? '1,2,3,5,6,7' : statusId.toString();
    this.apiParams.pageSize = 10;
    if (statusId !== this.statusId)
    {
      this.apiParams.currentPage = 1;
    }
    this.statusId = statusId;
    if(this.searchValue.length > 0)
    {
      this.onSearchPatients(this.searchValue);
      return;
    }

    this.apiParams.sort = this.invertSort;

    this.medicalRequestService.getRequests(this.apiParams).subscribe((res) => {
      this.requestArray = res.data.items;
      this.medicationRequestsCounter = res.data.medicationRequestsCounter;
      this.apiParams.currentPage = res?.data?.pagination.currentPage;
      this.totalItems = res?.data?.pagination.totalItems;
      for (var i = 0; i < this.requestArray.length; i++) {
        if (this.requestArray[i].emptyBoxesCount != 0 || '' || null || undefined) continue;
        if (this.requestArray[i].purchasesCount != 0 || '' || null || undefined) continue;
        if (this.requestArray[i].freeOfChargeCount != 0 || '' || null || undefined) continue;
        this.requestArray[i].emptyBoxesCount = null;
        this.requestArray[i].freeOfChargeCount = null;
        this.requestArray[i].purchasesCount = null;
      }

      this.buildTableRows();

    });
  }

  ExportTOExcel() {
    this.exportedRequestArray = [];
    var page_size = this.apiParams.pageSize;
    var current_page = this.apiParams.currentPage;
    this.apiParams['pageSize'] = this.totalItems;
    this.apiParams['currentPage'] = 1;

    if (this.searchValue?.length > 0)
    {
      this.apiParams.companyId == undefined ? this.apiParams.companyId = 0 : this.apiParams.companyId = Number(this.apiParams.companyId)
      this.medicalRequestService
        .searchMedicationRequests(this.searchValue.trim(), PspMedicalRequestTypeEnum.HomeDelivery,
          this.apiParams.medicationRequestStatusIds, this.apiParams.companyId, this.apiParams.currentPage, this.apiParams.pageSize)
        .subscribe((res) => {
          res.data.items.map((item) => {
            this.exportedRequestArray.push(item);
          });
          this.BuildExcel(this.exportedRequestArray);
        });
    }
    else {
      this.medicalRequestService.getRequests(this.apiParams).subscribe((res) => {
        res.data.items.map((item) => {
          this.exportedRequestArray.push(item);
        });
        this.BuildExcel(this.exportedRequestArray);
      });
    }
    this.apiParams.pageSize = page_size;
    this.apiParams.currentPage = current_page;
  }
  BuildExcel(exportedRequestArray): void {
    const data = [];

    const getChannelLabelFromId = (channelId: number) => {
      let label: string;

      switch (channelId) {
        case 1:
          label = 'Call';
          break;
        case 2:
          label = 'Application';
          break;
        default:
          label = 'Pharmacy';
          break;
      }
      return label;
    };

    exportedRequestArray.forEach((request) => {
      const excludeColumns = this.apiParams.companyId !== PspCompanyEnum.Roche && this.apiParams.companyId !== 0;

      data.push({
        'request Id': request.id,
        'channel Id': getChannelLabelFromId(request?.channelId),
        'full Name': request.patient?.fullName,
        'phone Number': request.patient?.phone,
        'patient City': request?.patientCity,
        'patient Area': request?.patientArea,
        'doctor Name': request.drName,
        ...(excludeColumns ? {} : {
          'doctor Code': request?.doctorCode,
          'Roche subscription code': (request?.doctorCode && request.patient.requestCompanyPspCode) ? `${request?.doctorCode}-${request.patient.requestCompanyPspCode}` : '',
          'Subscription History': request?.subscriptionHistory
        }),
        'program Name': request.programName,
        'company Name': request.companyName,
        'request Date': this.datePipe.transform(request.creationDate, "MMM d, y, h:mm a"),
        'pharmacy Name': request.pharmacy?.name,
        'pharmacy City': request.cityName,
        'pharmacy Area': request.areaName,

        'status Id':
          request?.statusId == 1
            ? 'Pending'
            : request?.statusId == 2
              ? 'Confirmed'
              : request?.statusId == 3
                ? 'Out for delivery'
                : request?.statusId == 4
                  ? 'Delivered'
                  : request?.statusId == 5
                    ? 'Cancelled'
                    : request?.statusId == 6
                      ? 'Expired'
                      : request?.statusId == 7
                      ? 'Pending Receipt'
                      : '',
        'discount Field': request.discountField == true ? 'Yes' : 'No',
        'the Order Quantity': request.theOrderQuantity == 0 || request.theOrderQuantity == null ? '' : request.theOrderQuantity,
        'total Public Price': request.totalPublicPrice == 0 || request.totalPublicPrice == null ? '' : request.totalPublicPrice,
        'percentage Of The Discount': request?.percentageOfTheDiscount <= 0 || request?.percentageOfTheDiscount == null ? '' : request.percentageOfTheDiscount + '%',
        'total Price After Discount': request.totalPriceAfterDiscount == 0 || request.totalPriceAfterDiscount == null ? '' : request.totalPriceAfterDiscount,
        'purchases Count': request?.emptyBoxesCount == 0 && request?.purchasesCount == 0 && request?.freeOfChargeCount == 0 ? '' : request?.purchasesCount,
        'free Of Charge Count': request?.emptyBoxesCount == 0 && request?.purchasesCount == 0 && request?.freeOfChargeCount == 0 ? '' : request?.freeOfChargeCount,
        'empty Boxes Count': request?.emptyBoxesCount == 0 && request?.purchasesCount == 0 && request?.freeOfChargeCount == 0 ? '' : request?.emptyBoxesCount,
        'psp Joining Date': this.datePipe.transform(request.pspJoiningDate, "MMM d, y, h:mm a"),
        'psp Code': request.patient.requestCompanyPspCode,
        'cancellation Reason': request.cancellationReason,

      })
    });

    this.excelService.download(data,'Requests');
 }

  onSearchPatients(searchVal: string) {
    // this.searchValue = searchVal;
    // this.pageSelectionId = 1;
    this.searchValue = searchVal;
    if (searchVal) {
      this.apiParams.companyId == undefined ? this.apiParams.companyId = 0 : this.apiParams.companyId = Number(this.apiParams.companyId)

      this.medicalRequestService
        .searchMedicationRequests(searchVal.trim(), PspMedicalRequestTypeEnum.HomeDelivery,
        this.apiParams.medicationRequestStatusIds, this.apiParams.companyId , this.apiParams.currentPage, this.apiParams.pageSize)
        .subscribe((res) => {
          // this.statusId = 0;
          this.requestArray = res.data.items;
          this.apiParams.currentPage = res?.data?.pagination.currentPage;
          this.totalItems = res.data.pagination.totalItems;

          for (var i = 0; i < this.requestArray.length; i++) {
            if (this.requestArray[i].emptyBoxesCount == 0 && this.requestArray[i].purchasesCount == 0
              && this.requestArray[i].freeOfChargeCount == 0) {
              this.requestArray[i].emptyBoxesCount = null;
              this.requestArray[i].freeOfChargeCount = null;
              this.requestArray[i].purchasesCount = null;
            }
          }
          this.buildTableRows();
        });
    }
    else {
      this.onSearch(this.statusId);
    }
  }

  routeToRequestDetails(requestId): void {
    const selectedReq = this.requestArray.find(
      (req) => req.id === requestId.selected[0].id
    ) as MedicalRequest;
    this.medicalRequestService.setSelectedRequest(selectedReq);
    this.router.navigate(['/psp/medication/request-details']);
  }

  routeToSelectPharmacy(requestId, e): void {
    e.stopPropagation();
    const selectedReq = this.requestArray.find(
      (req) => req.id === requestId
    ) as MedicalRequest;
    this.medicalRequestService.setSelectedRequest(selectedReq);
    this.openModal();
  }

  invertSorting() {
    this.invertSort = !this.invertSort;
    this.onSearch(this.statusId);
  }

  openModal(): void {
    const modalRef = this.modalService.open(NearestPharmacyModalComponent, {
      size: 'lg',
      backdrop: 'static',
      animation: true,
      centered: true,
    }).result.then((result) => {
      this.ngOnInit();
    });
  }

  onChangePage(pageDetails: ISmartTablePagination) {
    this.apiParams.currentPage = pageDetails.offset + 1;
    this.onSearch(this.statusId);
  }

  cancelClicked(event, pspRequest: MedicalRequest) {
    event.stopPropagation();
    this.onCancelRequest(pspRequest.id);
  }

  onCancelRequest(pspRequestId: number) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: "Test Request Files",
        subtitle: `Please upload test request results below by dragging the file or clicking upload files.`,
      },
    };

    this.modalRef = this.bsModalService.show(
      CancelRequestModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((cancellationReasonResponse) => {
      this.modalRef.hide();
      this.medicalRequestService.cancelMedicationRequest(pspRequestId, cancellationReasonResponse.cancellationReason)
        .subscribe((res) => {
          if (res.data.flag) {
            let requestIndex = this.requestArray.findIndex(r => r.id == pspRequestId);
            this.requestArray[requestIndex].statusId = 5;
            this.requestArray[requestIndex].canCancel = false;
            this.requestArray[requestIndex].cancellationReason = cancellationReasonResponse.cancellationReason;
            showNotification('success', 'The request has been cancelled successfully.', this.toastr);
          }
        });
    });
  }

  onCompanySelected(companyId: number): void {
    this.apiParams.currentPage = 1;
    this.apiParams.companyId = companyId;
    this.onSearch(this.statusId);
  }
  buildTableRows(): void {
    this.requestArray.forEach((request) => {
      const doctorCode = request?.doctorCode || '';
      const pspCode = request.patient?.requestCompanyPspCode || '';
      request['rocheSubscriptionCode'] = (doctorCode && pspCode) ? `${doctorCode}-${pspCode}` : '';
    });

    this.columns = [
      { prop: 'id', name: 'Request ID', width: 150 },
      {
        prop: 'channelId', name: 'Channel', pipe: {
          transform: (val) => {
            if (val == 1) return 'Call';
            else if (val == 2) return 'Application';
            else return 'Pharmacy';
          }
        }
      },
      { prop: 'patient.fullName', name: 'Patient Name' },
      { prop: 'patient.requestCompanyPspCode', name: 'Patient PSP Code', width: 160 },
      { prop: 'patient.phone', name: 'Mobile No.' },
      { prop: 'patientCity', name: 'Patient City' },
      { prop: 'patientArea', name: 'Patient Area' },
      { prop: 'drName', name: 'Doctor Name' },
      { prop: 'programName', name: 'Program Name' },
      { prop: 'companyName', name: 'Company Name' },
      { prop: 'creationDate', name: 'Request Date', pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y") } },
      { prop: 'pharmacy', name: 'Pharmacy', cellTemplate: this.selectPharmacy },
      { prop: 'cityName', name: 'Pharmacy City' },
      { prop: 'areaName', name: 'Pharmacy Area' },
      {
        prop: 'statusId', name: 'Status', pipe: {
          transform: (val) => {
            if (val == 1) return 'Pending';
            else if (val == 2) return 'Confirmed';
            else if (val == 3) return 'Out for delivery';
            else if (val == 4) return 'Delivered';
            else if (val == 5) return 'Cancelled';
            else if (val == 6) return 'Expired';
            else if (val == 7) return 'Pending Receipt';
            else return '';
          }
        }
      },
      { prop: 'discountField', name: 'Discount Applied', pipe: { transform: (val) => val === true ? 'Yes' : 'No' }, width: 165 },
      { prop: 'theOrderQuantity', name: 'Order Quantity', pipe: { transform: (val) => val === 0 || null ? '' : val } },
      { prop: 'totalPublicPrice', name: 'Total Public Price', pipe: { transform: (val) => val === 0 || null ? '' : val }, width: 165 },
      { prop: 'percentageOfTheDiscount', name: 'Discount Percentage', pipe: { transform: (val) => val == 0 || null ? '' : val + '%' }, width: 200 },
      { prop: 'totalPriceAfterDiscount', name: 'Total Price After Discount', pipe: { transform: (val) => val === 0 || null ? '' : val }, width: 225 },
      { prop: 'purchasesCount', name: 'purchases', pipe: { transform: (val) => val } },
      { prop: 'freeOfChargeCount', name: 'FOC', pipe: { transform: (val) => val }, width: 100 },
      { prop: 'emptyBoxesCount', name: 'Empty Boxes', pipe: { transform: (val) => val }, width: 150 },
    ]

    this.addRocheRequestsSpecificColumns();

    if (this.requestArray.some(r => r.cancellationReason)) {
      this.columns.push({ prop: 'cancellationReason', name: 'Cancellation Reason', width: 200 })
    }
    if (this.requestArray.some(r => r.canCancel)) {
      this.columns.push({ prop: 'canCancel', name: '', cellTemplate: this.cancelBtnRef, sortable: false });
    }
    if (this.apiParams.companyId === PspCompanyEnum.Roche || this.apiParams.companyId === 0) {
      const index = this.columns.findIndex(column => column.prop === 'drName');
      if (index !== -1) {
        this.columns.splice(index + 1, 0,
          { prop: 'doctorCode', name: 'Doctor Code', width: 150 },
          { prop: 'rocheSubscriptionCode', name: 'Roche Subscription Code', width: 200 },
          {
            prop: 'subscriptionHistory',
            name: 'Subscription History',
            width: 190,
            cellTemplate: this.subscriptionHistoryTemplate,
          });
      }
    }
  }

  private addRocheRequestsSpecificColumns() {
    this.columns.push({ prop: 'dischargeDate', name: 'Delivery Date', pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y") } });
    this.columns.push({
      prop: 'paymentMethods',
      name: 'Payment Methods',
      width: 200,
      pipe: { transform: (val) => val.join(', ') }
    });
    this.columns.push({
      prop: 'boxes',
      name: 'Pack’s Serial Number',
      width: 200,
      cellTemplate: this.packSerialNumberTemplate // Reference to template
    });
    this.columns.push({
      name: 'Serial Number Images',
      width: 200,
      cellTemplate: this.previewSerialNumberDocumentRef,
    });
    this.columns.push({
      name: 'Receipt',
      cellTemplate: this.previewReceiptDocumentRef,
    });
  }

  addExportRequest() {
    let obj = {
      patientPhoneOrPspCode:this.searchValue?.length > 0 ? this.searchValue : null,
      requestStatus:this.apiParams.medicationRequestStatusIds,
      companyId: this.apiParams.companyId,
      sheetType: 2,
      isHomeDelivery: true,
      pageSize: this.totalItems
    };

    this.medicalRequestService.addExportRequest(obj).subscribe(
      (response) => {
        if (response.data) {
          showNotification(
            'success',
            response.message,
            this.toastr
          );
        }
      }
    );
}

getBoxesTooltip(boxes: any[]): string {
    if (!boxes || boxes.length === 0) return '';
    
    return boxes.map((box, index) => `Pack ${index + 1} Serial Number: ${box.serialNumber}`).join('\n');
  }

   hasReceiptDocument(row: any):boolean{
      return row.receiptImage;
    }
  
    onReceiptDocumentButtonClick(row: any, event: MouseEvent): void {
      // Prevent from navigating to the patient details page
      event.preventDefault();
      event.stopPropagation();

      const modalRef = this.modalService.open(PreviewDocumentsModalComponent);
      modalRef.componentInstance.filesUrls = [row.receiptImage];
    }

    hasSerialNumberDocument(row: any):boolean{
      return row.boxes && row.boxes.some(box => box.imagePath);
    }
  
    onSerialNumberDocumentButtonClick(row: any, event: MouseEvent): void {
      // Prevent from navigating to the patient details page
      event.preventDefault();
      event.stopPropagation();

      const modalRef = this.modalService.open(PreviewDocumentsModalComponent);
      const boxesImages = row.boxes.map(box => box.imagePath);
      modalRef.componentInstance.filesUrls = boxesImages;
    }
}
